(function(app) {

    app.provider("accessTokenService",
        [
            function() {
                this.$get = [
                    function() {

                        function getAccessToken() {
                            return localStorage.getItem("DataAggregator.AccessToken");
                        }

                        function setAccessToken(accessToken) {
                            localStorage.setItem("DataAggregator.AccessToken", accessToken);
                        }

                        function removeAccessToken() {
                            localStorage.removeItem("DataAggregator.AccessToken");
                        }

                        var _observers = [];

                        function registerListener(listener) {
                            _observers.push(listener);
                        }

                        function notifyListeners() {
                            _observers.forEach(o => o());
                        }


                        function hasAdminAccess() {
                            const adminToken = "c9c39c07-086b-40d4-8a8b-ba120c1f3ab5";
                            if (localStorage.getItem("DataAggregator.AdminToken") === adminToken) {
                                return true;
                            }
                            return false;
                        }
                        
                        return {
                            getAccessToken: getAccessToken,
                            setAccessToken: setAccessToken,
                            removeAccessToken: removeAccessToken,
                            registerListener: registerListener,
                            notifyListener: notifyListeners,
                            hasAdminAccess: hasAdminAccess
                        };
                    }
                ];
            }
        ]);
})(window.app);